// Author YuJiaBei
// Date 2020-12-17 09:53:12

class EmActProcessStatus {
constructor({
        id = null,
        processRegisterId = '',
        processRegisterName = '',
        name = '',
        code = '',
        seq = '',
        allowModify = '',
        modifyEntity = '',
        modifySaveForm = '',
        modifyApi = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.processRegisterId = processRegisterId;
    this.processRegisterName = processRegisterName;
    this.name = name;
    this.code = code;
    this.seq = seq;
    this.allowModify = allowModify;
    this.modifyEntity = modifyEntity;
    this.modifySaveForm = modifySaveForm;
    this.modifyApi = modifyApi;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new EmActProcessStatus();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'processRegisterId',
        label: 'label.em.base.workflow.emActProcessStatus.grid.processRegisterId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'processRegisterDefinitionKey',
        label: 'label.em.base.workflow.emActProcessStatus.grid.processRegisterDefinitionKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'processRegisterName',
        label: 'label.em.base.workflow.emActProcessStatus.grid.processRegisterName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessStatus.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.base.workflow.emActProcessStatus.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.base.workflow.emActProcessStatus.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'allowModify',
        label: 'label.em.base.workflow.emActProcessStatus.grid.allowModify',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'modifyEntity',
        label: 'label.em.base.workflow.emActProcessStatus.grid.modifyEntity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'modifySaveForm',
        label: 'label.em.base.workflow.emActProcessStatus.grid.modifySaveForm',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'modifyApi',
        label: 'label.em.base.workflow.emActProcessStatus.grid.modifyApi',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessStatus.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessStatus.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    processRegisterIdFilter : "",
    processRegisterNameFilter : "",
    processBusinessEntityFilter : "",
    nameFilter : "",
    codeFilter : "",
    allowModifyFilter : "",
    modifyEntityFilter : "",
    modifySaveFormFilter : "",
    modifyApiFilter : "",
    statusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'processRegisterNameFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.processRegisterName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"processRegisterId":"id"}'
                }
        },
        {
        key: 'processBusinessEntityFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.processBusinessEntity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'allowModifyFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.allowModify',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'modifyEntityFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.modifyEntity',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'modifySaveFormFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.modifySaveForm',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'modifyApiFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.modifyApi',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.base.workflow.emActProcessStatus.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'processRegisterName',
        label: 'label.em.base.workflow.emActProcessStatus.entity.processRegisterName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"processRegisterId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.em.base.workflow.emActProcessStatus.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.base.workflow.emActProcessStatus.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.base.workflow.emActProcessStatus.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'allowModify',
        label: 'label.em.base.workflow.emActProcessStatus.entity.allowModify',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'modifyEntity',
        label: 'label.em.base.workflow.emActProcessStatus.entity.modifyEntity',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'modifySaveForm',
        label: 'label.em.base.workflow.emActProcessStatus.entity.modifySaveForm',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'modifyApi',
        label: 'label.em.base.workflow.emActProcessStatus.entity.modifyApi',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'status',
        label: 'label.em.base.workflow.emActProcessStatus.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.workflow.emActProcessStatus.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmActProcessStatus, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
